<template>
  <a
    v-if="props.href"
    class="inline-flex items-center justify-center gap-x-2 rounded-none border px-4 text-sm font-normal disabled:cursor-not-allowed"
    :class="computedClass"
    :target="props.target"
    :href="props.href"
    @mouseenter="$emit('mouseenter')"
    @focus="$emit('focus')"
  >
    <i
      class="fas fa-circle-notch fa-spin"
      v-if="loading"
    ></i>
    <slot v-else></slot>
  </a>
  <RouterLink
    v-else-if="props.to"
    :to="props.to"
    class="inline-flex items-center justify-center gap-x-2 rounded-none border px-4 py-3 text-sm font-normal text-white disabled:pointer-events-none"
    :class="computedClass"
    @mouseenter="$emit('mouseenter')"
    @focus="$emit('focus')"
  >
    <i
      class="fas fa-circle-notch fa-spin"
      v-if="loading"
    ></i>
    <slot v-else></slot>
  </RouterLink>
  <button
    v-else
    @click="$emit('click')"
    @mouseenter="$emit('mouseenter')"
    @focus="$emit('focus')"
    class="inline-flex items-center justify-center gap-x-2 rounded-none border px-4 text-sm font-normal disabled:cursor-not-allowed"
    :class="computedClass"
    :type="type"
    :disabled="disabled"
  >
    <i
      class="fas fa-circle-notch fa-spin"
      v-if="loading"
    ></i>
    <slot v-else></slot>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    color?: string;
    full?: boolean;
    href?: string;
    to?: string | object;
    target?: string;
    small?: boolean;
    type?: string;
    disabled?: boolean;
    loading?: boolean;
  }>(),
  {
    full: false,
    small: false,
    type: 'button',
  }
);

const computedClass = computed<string[]>(() => {
  const classes = [];
  if (props.full) {
    classes.push('w-full');
  }
  if (props.small) {
    classes.push('py-2.5');
  } else {
    classes.push('py-3');
  }

  if (props.disabled) {
    classes.push('opacity-60');
  }

  switch (props.color) {
    case 'primary':
      classes.push('border-frkbrown', 'bg-frkbrown', 'text-white', '', '', '', '');
      break;
    case 'secondary':
      classes.push('border-frkbrown-dark', 'bg-frkbrown-dark', 'text-white', '', '', '', '');
      break;
    case 'danger':
      classes.push('border-red-600', 'bg-red-600', 'text-white', '', '', '', '');
      break;
    default:
      classes.push(
        'border-[#D9D1CE]',
        'bg-white',
        'text-gray-500',
        'hover:bg-gray-100',
        '',
        '',
        '',
        '',
        '',
        ''
      );
      break;
  }
  return classes;
});
</script>
